module.exports = __webpack_public_path__ + "packs/media/images/lq-logo-2570f814c065343f30c527f876d7f73a.png";